import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { NewBulkPaymentForm } from 'modules/banking/components/CreateBulkPaymentForm'
import { useCreatePaymentForm } from 'modules/banking/components/CreateBulkPaymentForm/useForm'

export interface NewBatchPaymentModalProps {
  onClose: () => void
  onSuccess: (id: number) => void
}

export const NewPaymentModal = ({ onClose, onSuccess }: NewBatchPaymentModalProps) => {
  const { form: creationForm, loading: loadingCreation } = useCreatePaymentForm({
    onSuccess: onSuccess
  })

  const isValid =
    creationForm.isValid &&
    creationForm.values.label?.trim().length > 0 &&
    !!creationForm.values.bankAccountId

  const footer = (
    <Box flexDirection="row" gap="s8">
      <Button type="secondary" onClick={onClose}>
        {i18n.t('banking.bulk_payment.new_bulk_payment_modal.cancel')}
      </Button>
      <Button submit disabled={loadingCreation || !isValid}>
        {i18n.t('banking.bulk_payment.new_bulk_payment_modal.submit')}
      </Button>
    </Box>
  )

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('banking.bulk_payment.new_bulk_payment_modal.title')}
      description={i18n.t('banking.bulk_payment.new_bulk_payment_modal.description')}
      onClose={onClose}
      onSubmit={() => {
        track(trackingEvents.accounting.payments.clickContinueBulkPayment)
        creationForm.submitForm()
      }}
      footer={footer}
    >
      <NewBulkPaymentForm form={creationForm} />
    </Modal>
  )
}
